import React from "react";
import "./CourseElement.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignLeft,
  faChevronDown,
  faChevronUp,
  faEdit,
  faImage,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { MainContext } from "../contexts/MainContext";
import {
  dateDurationToFullStr,
  firebaseDateToDateObj,
} from "../functions/utils";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";

export default class BlockCourseElementManage extends React.Component<
  {
    clubId: string;
    branchId: string;
    courseId: string;
    title: string;
    description: string;
    internalNote: string;
    when: string;
    courses: Array<any>;
    freePlaces: number;
    price: string;
    imgUrl: string;
    editable: boolean;
    viewable: boolean;
    deleted: boolean;
  },
  { showMore: boolean }
> {
  static contextType = MainContext;
  constructor(props: any) {
    super(props);
    this.state = {
      showMore: false,
    };
  }

  toggleShowMore = () => {
    this.setState({ showMore: !this.state.showMore });
  };

  render() {
    return (
      <>
        <div
          className={`course-container ${
            this.props.deleted ? " grayscale" : ""
          }`}
          id={this.props.courseId}
        >
          {(this.props.editable || this.props.viewable) && (
            <div className="course-edit-icons">
              <Link
                to={`/club/${this.props.clubId}/branch/${this.props.branchId}/participants/${this.props.courseId}`}
                className="black"
              >
                <FontAwesomeIcon
                  icon={faUsers}
                  size="lg"
                  onClick={() => {}}
                  className="course-settings-icon"
                />
              </Link>
              {this.props.editable && (
                <>
                  <Link
                    to={`/club/${this.props.clubId}/branch-settings/${this.props.branchId}/feed?selemId=${this.props.courseId}`}
                    className="black"
                  >
                    <FontAwesomeIcon
                      icon={faAlignLeft}
                      size="lg"
                      onClick={() => {}}
                      className="course-settings-icon"
                    />
                  </Link>
                  <Link
                    to={`/club/${this.props.clubId}/branch/${this.props.branchId}/createCourse/${this.props.courseId}`}
                    className="black"
                  >
                    <FontAwesomeIcon
                      icon={faPlusSquare}
                      size="lg"
                      onClick={() => {}}
                      className="course-settings-icon"
                    />
                  </Link>
                  <Link
                    to={`/club/${this.props.clubId}/branch/${this.props.branchId}/edit-course/${this.props.courseId}`}
                    className="black"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      size="lg"
                      onClick={() => {}}
                      className="course-settings-icon"
                    />
                  </Link>
                </>
              )}
            </div>
          )}
          <div
            className={`inner-course-container ${
              this.props.editable ? "inner-course-container-editable" : ""
            }`}
          >
            <div>
              {!this.props.imgUrl ? (
                <div className="course-img">
                  <FontAwesomeIcon
                    icon={faImage}
                    size="6x"
                    className="image-icon"
                  />
                </div>
              ) : (
                <img
                  className="course-img"
                  src={this.props.imgUrl}
                  alt="Kursbild"
                />
              )}
            </div>
            <div className="course-info-container">
              <div className="course-info-inner-container">
                <div className="course-title-container">{this.props.title}</div>
                <div>{this.props.description}</div>
                <div className="course-text-container">
                  Termine:{" "}
                  <span className="normal-weight">
                    {this.props.courses.length}
                  </span>
                </div>
                <div className="course-text-container">
                  Wann:{" "}
                  <span className="normal-weight">
                    {this.props.courses
                      .slice(
                        0,
                        this.state.showMore ? this.props.courses.length : 3,
                      )
                      .map((course: any) => (
                        <div>
                          -{" "}
                          {dateDurationToFullStr(
                            firebaseDateToDateObj(course.startTime),
                            firebaseDateToDateObj(course.endTime),
                          )}
                        </div>
                      ))}
                  </span>
                  {this.props.courses.length > 3 && (
                    <div
                      className="more-info-container"
                      onClick={this.toggleShowMore}
                    >
                      <div className="more-info-inner-container">
                        {!this.state.showMore ? (
                          <FontAwesomeIcon icon={faChevronDown} size="sm" />
                        ) : (
                          <FontAwesomeIcon icon={faChevronUp} size="sm" />
                        )}
                      </div>
                      {this.state.showMore
                        ? "weniger anzeigen"
                        : "mehr anzeigen"}
                    </div>
                  )}
                </div>
                <div className="course-text-container">
                  Freie Plätze:{" "}
                  <span className="normal-weight">{this.props.freePlaces}</span>
                </div>
                {this.props.internalNote && (
                  <div className="course-text-container">
                    Interne Notiz:{" "}
                    <span className="normal-weight">
                      {this.props.internalNote}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
